import { Box } from "@mui/material";
import ChatWindow from "./ChatWindow";
import CallHistoryWindow from "./CallHistoryWindow";
import CombinedActivityWindow from "./CombinedActivityWindow";
import { useChatContext } from "../hooks/ChatProvider";

// Right panel for a selected contact. The outer Chat/Calls/All tabs
// (ChatDashboard.js) filter the left-panel list AND, per activeTab below,
// decide what this panel shows: selecting a contact from "Chat" or
// "Calls" specifically always shows that one channel, even if the
// contact has both — only a contact selected from "All" who has both
// channels gets the merged CombinedActivityWindow (replacing the earlier
// Chat/Calls sub-tab switcher — see interleave-chat-call-activity's
// design.md Decision 4 and proposal.md). Reuses ChatWindow and
// CallHistoryWindow completely unmodified for the single-channel cases.
const ContactDetailWindow = ({ setIsChatSelected, activeTab }) => {
  const { selectedUser } = useChatContext();

  if (!selectedUser) {
    // ChatWindow already renders its own "no conversation selected" empty
    // state for a null selectedUser — reused here rather than duplicating it.
    return <ChatWindow setIsChatSelected={setIsChatSelected} />;
  }

  const hasBoth = Boolean(selectedUser.has_chat) && Boolean(selectedUser.has_call);

  if (activeTab === "all" && hasBoth) {
    return <CombinedActivityWindow />;
  }

  // Only one channel exists, or the outer tab forces a single channel:
  // "chats"/"calls" always show that one; otherwise (the "All" tab with
  // a single-channel contact) fall back to whichever channel they
  // actually have — avoids ever landing on an empty ChatWindow for a
  // call-only contact (or vice versa).
  const activeView =
    activeTab === "chats" ? "chats" : activeTab === "calls" ? "calls" : selectedUser.has_call ? "calls" : "chats";

  return (
    <Box display="flex" flexDirection="column" height="100%" width="100%" minWidth={0}>
      <Box flex={1} minHeight={0}>
        {activeView === "calls" ? (
          <CallHistoryWindow caller={selectedUser.phone} callerName={selectedUser.name} />
        ) : (
          <ChatWindow setIsChatSelected={setIsChatSelected} />
        )}
      </Box>
    </Box>
  );
};

export default ContactDetailWindow;
